export default __webpack_public_path__ + "static/media/AdSea_07.8ea14cbb.png";